/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import PushService from 'cio/services/push';
import AuthService from 'cio/services/auth';

interface FileInputArgs {
  provider: 'apns' | 'fcm';
  canEdit: boolean;
  isEditing: boolean;
  fileName?: string;
  selectedFile?: any;
  onFileSelected: (file: any, resetInput: boolean) => unknown;
}

const FILE_INPUT_CONFIG = {
  apns: {
    type: 'p8',
    label: 'Certificate',
    name: 'certificate_upload',
    preview: `-----BEGIN PRIVATE KEY-----
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
-----END PRIVATE KEY-----`,
  },
  fcm: {
    type: 'json',
    label: 'Server Key',
    name: 'server_key_upload',
    preview: `{ 
  "type": "XXXXXX", 
  "project_id": "XXXXXX", 
  "private_key_id": "XXXXXX", 
  "private_key": "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX`,
  },
};

export default class FileInput extends Component<FileInputArgs> {
  @service push!: PushService;
  @service auth!: AuthService;

  get canEdit() {
    return this.args.canEdit ?? true;
  }

  get isEditing() {
    return this.canEdit && this.args.isEditing;
  }

  get fileInputConfig() {
    return FILE_INPUT_CONFIG[this.args.provider];
  }

  get fileExtension() {
    return `.${this.fileInputConfig?.type}`;
  }

  get fileNameToDisplay() {
    return this.args.selectedFile != null ? this.args.selectedFile.name : `${this.args.fileName} (current)`;
  }

  get isEmpty() {
    return this.args.fileName == null && this.args.selectedFile?.name == null;
  }
}
